import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-moment-media',
  name: '动态媒体',
  icon: '媒',
  group: '动态详情页',
  description: '展示动态图片画廊或单视频媒体，并保持媒体顺序。',
  defaultProps: {
    mediaMode: 'GALLERY_OR_VIDEO',
    galleryFit: 'COVER',
    galleryIndicator: 'NUMBER',
    videoFit: 'COVER',
    autoplay: false,
    muted: true,
    loop: false
  }
}
